/* eslint-disable no-restricted-imports */
import { FC, useMemo } from 'react';
import { PostModel } from '../../../data-layer/posts/types';
import { hasAvailableProducts } from '../../../utils/hasAvailableProducts';
import { useExperimentFlag } from '../../../utils/useExperimentFlag';
import { DEFAULT_ICON_PROPS } from './constants';
import { IconWrapper } from './styles';
import { PostCardGridIconsProps } from './typings';
import { getIconOffset } from './utils/getIconOffset';
import { getPostCardGridIcons } from './utils/getPostCardGridIcons';

export const PostCardGridIcons: FC<PostCardGridIconsProps> = ({
    post,
    withProductsPreview,
    additionalIcon,
    index,
}) => {
    const withCheckout =
        Number(useExperimentFlag('products_checkout')) === 2 &&
        post.products.items.some((product) => product.checkout?.url);

    const icons = useMemo(
        () =>
            getPostCardGridIcons(post, {
                withProductsPreview: withProductsPreview && hasAvailableProducts(post as PostModel),
                withCheckout,
            }),
        [post, withCheckout, withProductsPreview],
    );

    return (
        <>
            {additionalIcon ? (
                <IconWrapper key={index} right={getIconOffset(0)} top={1} zIndex={1}>
                    {additionalIcon}
                </IconWrapper>
            ) : null}
            {icons.map(({ Icon }, i) => {
                const rightOffset = getIconOffset(additionalIcon ? i + 1 : i);

                return (
                    <IconWrapper key={i} right={rightOffset} top={1} zIndex={1}>
                        <Icon {...DEFAULT_ICON_PROPS} />
                    </IconWrapper>
                );
            })}
        </>
    );
};
